'use strict';

// 站点默认颜色( 如果需要修改默认颜色，需要同时修改static\css\common.css文件中定义的全局默认颜色 )
export const SITE_COLOR_DEFAULT = {
  theme_color: '#41bfbf', // 默认主题颜色
  //warning_color: '#ec6459', // 默认警示色
  //tip_color: '#ff850d', // 默认提示色
  auxiliary_color: '#4883c0', // 默认主按钮颜色
  auxiliary_bg_color: '#97a9b2', // 默认操作弹窗背景色
  //text_color: '#333333', // 默认警示文字颜色 警示背景颜色
  text_content_color: '#555555' // 默认条件标签颜色
  //text_title_color: '#909399', // 默认表格小标题颜色
  //text_auxiliary_color: '#999999', // 默认辅助文字色
  //text_watermark_color: '#cccccc', // 默认水印色
  // division_color: '#f5f9fc', // 默认系统背景颜色 表格背景色
  // table_division_color: '#ebeef5', // 默认表格分割符颜色
  // contact_division_color: '#e8e8e8' // 默认联系方式侧边栏颜色
};

// 颜色key对应css全局设置
export const SITE_COLOR_KEY_INDEX = {
  theme_color: 'theme-color',
  //warning_color: 'warning-color',
  //tip_color: 'tip-color',
  auxiliary_color: 'auxiliary-color',
  auxiliary_bg_color: 'auxiliary-bg-color',
  //text_color: 'text-color',
  text_content_color: 'text-content-color'
  //text_title_color: 'text-title-color',
  //text_auxiliary_color: 'text-auxiliary-color',
  //text_watermark_color: 'text-watermark-color',
  // division_color: 'division-color',
  // table_division_color: 'table-division-color',
  // contact_division_color: 'contact-division-color'
};

// 辅助颜色显示
export const SITE_AUXILIARY_SHOW = [
  //{ key: 'warning_color', desc: '通用警示色' },
  //{ key: 'tip_color', desc: '通用提示色' },
  { key: 'text_content_color', desc: '条件标签颜色' },
  { key: 'auxiliary_bg_color', desc: '操作弹窗背景色' },
  { key: 'auxiliary_color', desc: '主按钮色' }
];

// 文字颜色显示
export const SITE_TEXT_SHOW = [
  //{ key: 'text_color', desc: '通用警示文字及背景颜色' },
  //{ key: 'text_content_color', desc: '通用内容文字颜色' },
  //{ key: 'text_title_color', desc: '表格小标题颜色' },
  //{ key: 'text_auxiliary_color', desc: '辅助文字色' },
  //{ key: 'text_watermark_color', desc: '水印色' }
];

// 背景/分割线显示
export const SITE_DIVISION_SHOW = [
  // { key: 'division_color', desc: '系统背景颜色,表格背景色' },
  // { key: 'table_division_color', desc: '表格分割符颜色' },
  // { key: 'contact_division_color', desc: '联系方式侧边栏颜色' }
];



// WEBPACK FOOTER //
// ./src/common/appConstant.js